import React from "react";

const TestimonialsCard = ({
  topBg,
  rating,
  content,
  authorImg,
  authorName,
  authorDesignation,
  bottomBg,
  bottomBgHover,
  wowDelay = "000ms",
}) => (
  <div
    className="testimonials-card wow fadeInUp"
    data-wow-duration="1500ms"
    data-wow-delay={wowDelay}
  >
    <div
      className="testimonials-card__top-bg"
      style={topBg ? { backgroundImage: `url(${topBg})` } : undefined}
    ></div>
    <div className="testimonials-card__rating">
      {[...Array(rating)].map((_, i) => (
        <i className="fa fa-star" key={i} />
      ))}
    </div>
    <div className="testimonials-card__content">{content}</div>
    <div className="testimonials-card__author">
      <img src={authorImg} alt={authorName} />
      <h3 className="testimonials-card__name">{authorName}</h3>
      <p className="testimonials-card__designation">{authorDesignation}</p>
    </div>
    <div
      className="testimonials-card__bottom-bg"
      style={bottomBg ? { backgroundImage: `url(${bottomBg})` } : undefined}
    ></div>
    <div
      className="testimonials-card__bottom-bg-hover"
      style={bottomBgHover ? { backgroundImage: `url(${bottomBgHover})` } : undefined}
    ></div>
  </div>
);

export default TestimonialsCard;
